<template>
   <div class="crud-wrapper">
      <crud-toolbar :modal-mode="modalMode" :new-state="newState" :title="modalTitle"
                    @onCommand="toolbarCommand"></crud-toolbar>

      <crud-form :modal-mode="modalMode" :ref="formName" v-model="validForm">

         <v-layout row wrap>

            <a-select-field :disabled="cantEdit" :suggestions="workingStores" label="Campanha para Empresa" sm7
                            v-if="multiStore && !newState"
                            v-model="formData.companyId" validate="required"></a-select-field>

            <a-select-field :disabled="cantEdit || reprocess" height="32" label="Convênio" obj="covenant" sm6
                            v-model="formData.covenantId" validate="required"></a-select-field>

            <a-select-field clearable height="32" label="Foco Específico da campanha" obj="productType" sm6
                            v-model="formData.typeId"></a-select-field>

            <a-text-field :disabled="cantEdit || reprocess" autofocus label="Nome da Campanha" v-model="formData.name"
                          validate="required"></a-text-field>

            <a-select-field chips clearable label="Bancos permitidos para Refin" multiple
                            obj="bank" v-model="formData.banksRefinance"></a-select-field>
            <a-select-field chips clearable label="Bancos permitidos para Portabilidade" multiple
                            obj="bank" v-model="formData.banksPortable"></a-select-field>

            <a-text-area-field label="Objetivos dessa Campanha" v-model="formData.goal"></a-text-area-field>

            <a-select-field label="Fila do Discador Automático" obj="dialerQueue" sm6
                            v-model="formData.queueId"></a-select-field>

         </v-layout>

         <template slot="rightContent">
            <v-card class="mb-4" color="rgba(0,0,0, 0.03)" flat style="border-radius:12px;">
               <v-layout align-center pa-3 row>
                  <v-flex column xs10>
                     <label class="v-label v-label--active theme--light aLabel">Situação da Campanha</label>
                     <label :class="formData.statusColor" class="title font-weight-bold">{{formData.statusName}}</label>
                     <v-divider class="my-1"></v-divider>
                     <label class="v-label">Contatos na Campanha: <b>{{formData.namesQty | fmtFixedInt}}</b></label>
                  </v-flex>
                  <v-flex mr-2 xs2>
                     <campaign-status-fab :fabSettings="{dark:true}" :statusCommands="formData.commands"
                                          :statusIcon="formData.statusIcon" @onFabCommand="fabCommand"
                                          fabColor="secondary">
                     </campaign-status-fab>
                  </v-flex>
               </v-layout>
            </v-card>
            <v-card color="rgba(0,0,0, 0.03)" flat style="border-radius:12px;">
               <v-card-title class="pb-1 title text-truncate text-no-wrap" primary-title>
                  Estatísticas
               </v-card-title>
               <v-card-text>
                  <v-layout row wrap>
                     <v-flex column xs4>
                        <label class="v-label v-label--active theme--light aLabel text-xs-right">Contatos
                           Processados</label>
                        <label class="title text-xs-right" style="display: block;">
                           {{formData.namesTried | fmtFixedInt}}</label>
                        <v-divider class="my-1" inset></v-divider>
                        <label class="title text-xs-right" style="display: block;">
                           {{formData.processedPercent | fmtPercent}}</label>
                     </v-flex>
                     <v-flex column xs4>
                        <label class="v-label v-label--active theme--light aLabel text-xs-right">Contatos
                           Alcançados</label>
                        <label class="title text-xs-right" style="display: block;">
                           {{formData.namesReached | fmtFixedInt}}</label>
                        <v-divider class="my-1" inset></v-divider>
                        <label class="title text-xs-right" style="display: block;">
                           {{formData.reachedPercent | fmtPercent}}</label>
                     </v-flex>
                     <v-flex column xs4>
                        <label class="v-label v-label--active theme--light aLabel text-xs-right">Negócios
                           Gerados</label>
                        <label class="title text-xs-right" style="display: block;">
                           {{formData.namesDeals | fmtFixedInt}}</label>
                        <v-divider class="my-1" inset></v-divider>
                        <label class="title text-xs-right" style="display: block;">
                           {{formData.successPercent | fmtPercent}}</label>
                     </v-flex>
                  </v-layout>
               </v-card-text>
            </v-card>
         </template>

      </crud-form>

   </div>


</template>

<script>
    import CrudFormClass from '@consigmais-team/vue-common/layout/crudPage/crudFormClass';
    import CampaignStatusFab from '../components/CampaignStatusFab';

    export default CrudFormClass.extend({
        name: 'CampaignForm',

        components: { CampaignStatusFab },

        data: function () {
            return {
                title: 'Campanha',
                formName: 'campaignForm',
                fabCommandRunning: null,

                formData: {
                    id: null,
                    companyId: null,
                    name: null,
                    goal: null,
                    statusId: 50,
                    covenantId: null,
                    productId: null,
                    campaignId: null,
                    typeId: null,
                    banksRefinance: null,
                    banksPortable: null,
                    queueId: null,
                    voipKey: null,
                    dataRequest: null,
                    dailyPeriod: null,
                    namesQty: 0,
                    namesTried: 0,
                    namesReached: 0,
                    namesDeals: 0,
                    processedPercent: 0,
                    reachedPercent: 0,
                    successPercent: 0,
                    commands: null,
                    statusName: null,
                    statusIcon: null,
                    statusColor: null
                }

            };
        },

        async created () {
            if (this.newState) {
                let status = await this.$api.dataService.search('campaignStatus', { id: this.formData.statusId });
                if (status) {
                    this.formData.statusName = status[0].name;
                    this.formData.statusColor = status[0].color;
                    this.formData.commands = status[0].commands;
                    this.formData.statusIcon = status[0].icon;
                }
            }
        },

        computed: {
            workingStores () {
                return this.$store.state.company.brandStores.filter(f => f.id > 0);
            },

            cantEdit () {
                return (this.formData.statusId >= 60);
            },

            reprocess () {
                return Boolean(this.formData.campaignId);
            },

            multiStore () {
                return this.$store.state.company.multiStore && !this.$store.state.company.isPartner;
            },

            statusName () {
                let statusName;

                switch (this.formData.status) {
                    case 'W':
                        statusName = 'Pronta para Iniciar';
                        break;
                    case 'S':
                        statusName = 'Pausada';
                        break;
                    case 'R':
                        statusName = 'Em Execução';
                        break;
                    case 'F':
                        statusName = 'Concluída';
                        break;
                    case 'C':
                        statusName = 'Cancelada';
                        break;
                    case 'Q':
                        statusName = 'Fila de Processamento';
                        break;
                    default:
                        statusName = 'Nenhum Contato Adicionado';
                }

                return statusName;
            }

        },

        methods: {
            afterSave (data) {
                if (this.fabCommandRunning) {
                    console.log('SAVED: ', data);
                    this.setEditState(data.id, data);
                    setTimeout(() => this.fabCommand(this.fabCommandRunning), 100);
                }
            },

            dataRequestDone () {
                this.loadFormData();
            },

            showDataRequestForm (route) {
                window.getApp.showModal(route,
                    {
                        props: { campaign: this.formData },
                        modalWidth: 600,
                        doneCallback: this.dataRequestDone
                    }
                );
            },

            async fabCommand (cmd) {
                let skip = await this.validateForm()
                    .then(() => false)
                    .catch(() => {
                        this.$notifyUser({
                            type: 'warning',
                            message: `Favor preencher todos os campos obrigatórios antes.`,
                            position: 'top right'
                        });

                        return true;
                    });

                if (skip) return;


                if (this.newState) {
                    this.fabCommandRunning = cmd;
                    await this.save();
                    return;
                }

                this.fabCommandRunning = null;

                switch (cmd) {
                    case 'import':
                        this.showDataRequestForm('CampaignDataImport');
                        break;
                    case 'askData':
                        this.showDataRequestForm('CampaignDataFilter');
                        break;
                    default:
                        let params = {
                            cmd,
                            statusId: this.formData.statusId
                        };
                        let res = await this.$api.dataService.execute('campaign/statusChangeCmd', params, this.formData.id);
                        console.log(res);
                        if (res) {
                            if (res.statusId === 60) {
                                this.$notifyUser({
                                    type: 'success',
                                    message: `Nova Campanha ${'RP: ' + res.name} gerada com sucesso.`
                                });
                            } else {
                                this.$notifyUser({
                                    type: 'success',
                                    message: `Situação de ${res.name} alterada com sucesso.`
                                });
                            }
                            this.loadFormData(null, res);
                        }
                }

                this.formSaved = true;

            }

        }

    });
</script>

<style scoped>
   .bigNumber {
      font-size: 40px;
      font-weight: 400;
   }

   .biggerNumber {
      font-size: 60px;
      font-weight: 500;
      color: orange;
   }

</style>



// WEBPACK FOOTER //
// src/pages/CampaignForm.vue